export enum OfferStatusType {
  SEND = '569331ac-61f9-4649-a7a5-d58ddad80ecb',
  PREPARED = '9ace979d-6d50-461e-ab4c-4dae0a03861f',
  APPROVED = 'e4a61bce-6d96-45de-ab0f-2ab4ef834a43',
  REJECTED = 'fabe158d-ac09-4a7d-9f80-8b6f2a3b24fc',
}
